import type { FC, ReactNode } from "react";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import type { PopupProps } from "tw/components/molecules/Popup";
import { Popup } from "tw/components/molecules/Popup";

type PopupContextType = {
  showPopup: (popup: PopupProps) => void;
};

const PopupContext = createContext<PopupContextType>({
  showPopup: () => {},
});

export const PopupProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [popup, setPopup] = useState<PopupProps | null>(null);

  const showPopup = useCallback((newPopup: PopupProps) => {
    setPopup(newPopup);
  }, []);

  const closePopup = useCallback(() => {
    setPopup(null);
  }, []);

  const contextValues = useMemo(() => ({ showPopup }), [showPopup]);

  return (
    <PopupContext.Provider value={contextValues}>
      {children}
      {popup && <Popup {...popup} onClose={closePopup} />}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);
